import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AppButton from '../components/AppButton';

function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const hasVerified = useRef(false);

    const [status, setStatus] = useState('Verifying your email...');
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        if (hasVerified.current) return;
        hasVerified.current = true;

        const verify = async () => {
            try {
                const token = searchParams.get('token');

                if (!token) {
                    setStatus('Verification token is missing.');
                    setIsSuccess(false);
                    return;
                }

                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/auth/verify-email?token=${token}`
                );

                const result = await response.json();

                if (result.success) {
                    setStatus('Email verified successfully. Redirecting to login...');
                    setIsSuccess(true);

                    setTimeout(() => {
                        navigate('/login');
                    }, 2000);
                } else {
                    setStatus(result.message || 'Verification link is invalid or has expired.');
                    setIsSuccess(false);
                }
            } catch (err) {
                setStatus('Something went wrong while verifying your email.');
                setIsSuccess(false);
            }
        };

        verify();
    }, [searchParams, navigate]);

    return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
            <h2>Email Verification</h2>
            <p>{status}</p>

            {!isSuccess && (
                <AppButton onClick={() => navigate('/login')}>
                    Back to Login
                </AppButton>
            )}
        </div>
    );
}

export default VerifyEmail;